import styles from './IconExplanationFormSelect.module.scss';
import { as } from '@phi/util/types';
import { PropType, VNode, defineComponent, h } from 'vue';
import FormSelect from './FormSelect';

type Entry<T> = {
    value: T;
    icon: VNode | string;
    title: VNode | string;
    subtitle: VNode | string;
    disabled?: boolean;
}

export default <T>() => {
    const FormSelectT = FormSelect<T>();
    return defineComponent({
        props: {
            value: {
                required: true,
                type: as<PropType<T>>(null),
            },

            options: {
                required: true,
                type: Array as PropType<Array<Entry<T>>>,
            },
        },

        emits: {
            'update:value': (x: T) => true,
        },

        render() {
            return h(FormSelectT, {
                class: 'icon-explanation-form-select',
                value: this.value,
                'onUpdate:value': x => this.$emit('update:value', x),
                options: this.options.map(x => ({
                    value: x.value,
                    text: () => h('div', { class: styles.slot }, [
                        x.icon === 'string'
                            ? h('img', { class: styles.icon, src: x.icon })
                            : h('div', { class: styles.icon }, x.icon),

                        h('div', [
                            h('div', { class: styles.title }, x.title),
                            h('div', x.subtitle),
                        ]),
                    ]),
                    disabled: x.disabled,
                })),
            });
        },
    });
};
